import { useMutation, useQuery } from '@tanstack/react-query'
import { getCommonContent, getQuestions, fillContactUsForm } from '../api/common'

export const useGetCommonContentQuery = () => {
    return useQuery({
        queryKey: ['common_content'],
        queryFn: () => getCommonContent()
    });
};

export const useGetFAQQuery = () => {
    return useQuery({
        queryKey: ['faqs'],
        queryFn: () => getQuestions()
    });
};

export const useFillContactUsForm = () => {
    return useMutation({
        mutationFn: fillContactUsForm
    })
};